import { Link, useLocation } from 'react-router-dom';
import { links, translations } from '../../../utils/staticContent';
import './style.scss';

function Navigation() {
    const { pathname } = useLocation();
    return (
        <nav className="Navigation container">
            <Link to={links.shows} className="nav-item nav-first">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="195.54 271.17 203.71 53.12"
                >
                    <polygon
                        className={`svg-shape ${pathname.includes(links.shows) ? 'selected' : ''}`}
                        points="373.75,324.29 399.25,281.79 221.37,271.17 195.54,315.58 "
                    />
                    <text
                        transform="matrix(0.9985 0.0552 -0.0552 0.9985 265.1925 302.4046)"
                        className={`svg-text ${pathname.includes(links.shows) ? 'selected' : ''}`}
                    >
                        {translations.shows}
                    </text>
                </svg>
            </Link>
            <Link to={links.articles} className="nav-item nav-second">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="206.52 271.6 181.43 52.25"
                >
                    <polygon
                        className={`svg-shape ${
                            pathname.includes(links.articles) ? 'selected' : ''
                        }`}
                        points="206.52,315.6 235.02,271.6 370.85,279.9 387.95,323.85 206.52,315.6 "
                    />
                    <text
                        transform="matrix(0.9985 0.0552 -0.0552 0.9985 271.9626 303.2086)"
                        className={`svg-text ${
                            pathname.includes(links.articles) ? 'selected' : ''
                        }`}
                    >
                        {translations.articles}
                    </text>
                </svg>
            </Link>
            <Link to={links.events} className="nav-item nav-third">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="317.303 571.672 207.197 47.328"
                >
                    <polygon
                        className={`svg-shape ${pathname.includes(links.events) ? 'selected' : ''}`}
                        points="510,581.5 524.5,619 331.836,613.434 317.303,571.672 "
                    />
                    <text
                        transform="matrix(0.9993 0.0371 -0.0371 0.9993 383.9146 601.3516)"
                        className={`svg-text ${pathname.includes(links.events) ? 'selected' : ''}`}
                    >
                        {translations.events}
                    </text>
                </svg>
            </Link>
            <Link to={links.projects} className="nav-item nav-fourth">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="323.5 574 193.818 41"
                >
                    <polygon
                        className={`svg-shape ${
                            pathname.includes(links.projects) ? 'selected' : ''
                        }`}
                        points="323.5,574 337.5,610 505.196,614.949 517.318,583.168 "
                    />
                    <text
                        transform="matrix(0.9997 0.0263 -0.0263 0.9997 383.0078 600.665)"
                        className={`svg-text ${
                            pathname.includes(links.projects) ? 'selected' : ''
                        }`}
                    >
                        Projekti
                    </text>
                </svg>
            </Link>
        </nav>
    );
}

export default Navigation;
